export default __webpack_public_path__ + "static/SR USA - BRC Certificate - Food Safety-4f900702fe0ff4a330ce4331284e6692.pdf";